import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnEditReview(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos atualizar a versão.'
            break
        case '2xx':
            message = 'Atualizamos a versão.'
            break
        case 401:
            message =
                'Ops! O seu tempo de acesso expirou, para continuar utilizando o sistema é necessário realizar o login.'
            break
        case 403:
            message = 'Permissão Negada.'
            break
        case 500:
        default:
            message =
                'Ops! Algo de estranho ocorreu e não alteramos a versão do eitri-app. Por favor, tente novamente mais tarde.'
    }
    return message
}
